import withAemIntegration from "../../../withAemIntegration";
import loadable from "../../../utils/loadable";
import { purifyText } from "@lexus.com/ui/dist/utilities";

const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/DriversFeatureSet")
);

const ComponentEditConfig = {
  emptyLabel: "Content Fragment List",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props) => {
  return {
    ...props,
    items: (props.items || []).map((item) => ({
      model: item?.model,
      heading: item.elements?.headline?.value,
      shortDescription: item.elements?.shortDescription?.value,
      longDescription: item.elements?.longDescription?.value,
      dateCreated: item.elements?.dateCreated?.value,
      state: item.elements?.state?.value,
      media: {
        image: {
          eagerLoad: false,
          desktop: {
            alt: "",
            src: item.elements?.thumbnail?.value ||
              (item.elements?.youtubeID?.value
                ? "https://i.ytimg.com/vi/" + item.elements.youtubeID.value + "/mqdefault.jpg"
                : undefined)
          },
        },
      },
      srcDesktop: item.elements?.srcDesktop?.value,
      srcMobile: item.elements?.srcMobile?.value,
      cta: {
        type: item?.model === "lexus/models/video" ? "button" : "text",
        text: item?.model === "lexus/models/video" ? "WATCH VIDEO" : "READ MORE",
        href: item.elements?.href?.value,
        target: "_self",
        theme: "SecondaryBlack",
        isActive: false,
      },
      category: item.elements?.category?.value,
      modelYear: item.elements?.modelYear?.value,
      topic: item.elements?.topic?.value,
    })),
  };
};

const ContentFragmentList = (props) => {
  const data = transformData(props);
  return <Component {...data} />;
};

export default withAemIntegration(
  "lexus/components/drivers/content-fragment-list"
)(ContentFragmentList, ComponentEditConfig);
